import React from "react";
import {
  FeaturedLocalVideoContainer,
  FeaturedVideoContainer,
  LocalVideo,
} from "./SliceFeaturedVideo.styles";
import { VimeoVideo } from "../../Video/Video";
import { BaseContainerProps } from "../../Container/Container";

export interface PureFeaturedVideoProps extends BaseContainerProps {
  vidId: string;
  rounded?: boolean;
  shadows?: boolean;
  fullWidth?: boolean;
  marginTop?: boolean;
}

export function PureFeaturedVideo({
  vidId,
  rounded = true,
  shadows = true,
  fullWidth = false,
  marginTop,
  ...props
}: PureFeaturedVideoProps) {
  return (
    <FeaturedVideoContainer fullWidth={fullWidth} {...props}>
      <VimeoVideo
        vidId={vidId}
        shadows={shadows}
        rounded={rounded}
        marginTop={marginTop}
      />
    </FeaturedVideoContainer>
  );
}

export interface PureFeaturedLocalVideoProps extends BaseContainerProps {
  videoUrl: string;
  videoPoster?: string;
  videoSize?: "normal" | "wide" | "full screen" | "small";
  rounded?: boolean;
  shadows?: boolean;
  loopVideo?: boolean;
  muteVideo?: boolean;
  showControls?: boolean;
  autoPlay?: boolean;
}

export function PureFeaturedLocalVideo({
  videoUrl,
  videoPoster,
  rounded = false,
  shadows = false,
  loopVideo,
  muteVideo,
  showControls,
  autoPlay,
  videoSize = "normal",
  ...props
}: PureFeaturedLocalVideoProps) {
  return (
    <FeaturedLocalVideoContainer
      {...props}
      isWide={videoSize === "wide"}
      fullWidth={videoSize === "full screen" || videoSize === "wide"}
    >
      <LocalVideo
        $size={videoSize}
        $shadows={shadows}
        $rounded={rounded}
        muted={muteVideo}
        controls={showControls}
        playsInline
        autoPlay={autoPlay}
        loop={loopVideo}
        poster={videoPoster}
      >
        <source src={videoUrl} type="video/mp4" />
      </LocalVideo>
    </FeaturedLocalVideoContainer>
  );
}
